import { render, staticRenderFns } from "./SelectedCourseContent.vue?vue&type=template&id=3d4c65a9&scoped=true&"
import script from "./SelectedCourseContent.vue?vue&type=script&lang=ts&"
export * from "./SelectedCourseContent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedCourseContent.vue?vue&type=style&index=0&id=3d4c65a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c65a9",
  null
  
)

export default component.exports